export default "__VITE_ASSET__0a25687d__$_?react__"